<template>
    <div class="container">
        <div class="row justify-content-between align-items-center g-2 booker-container">
            <!-- Select de Años -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <select v-model="selectedYear" @change="handleYearChange" :disabled="isLoading">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                    </select>
                    <div v-if="isLoading" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Select de Marcas -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <select v-model="selectedMarca" @change="handleMarcaChange" :disabled="isLoadingMarcas">
                        <option disabled value="0">Marca</option>
                        <option v-for="marca in marcas" :key="marca" :value="marca">{{ marca }}</option>
                    </select>
                    <div v-if="isLoadingMarcas" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Select de Modelo -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <select v-model="selectedModelo" :disabled="isLoadingModelo || modelos.length === 0"
                        @change="handleModeloChange">
                        <option disabled value="0">Modelo</option>
                        <option v-for="modelo in modelos" :key="modelo" :value="modelo">{{ modelo }}</option>
                    </select>
                    <div v-if="isLoadingModelo" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Select de Motor -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <select v-model="selectedMotor" :disabled="isLoadingMotor || motores.length === 0"
                        @change="handleMotoresLineasChange">
                        <option value="0">Motor</option>
                        <option v-for="motor in motores" :key="motor" :value="motor">{{ motor }}</option>
                    </select>
                    <div v-if="isLoadingMotor" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Select de Línea -->
            <div class="col-12 col-md-2">
                <div class="select w-100">
                    <select v-model="selectedLinea" :disabled="isLoadingLineas || lineas.length === 0"
                        @change="handleMotoresLineasChange">
                        <option value="0">Linea</option>
                        <option v-for="linea in lineas" :key="linea.id" :value="linea.id">{{ linea.name }}</option>
                    </select>
                    <div v-if="isLoadingLineas" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border" role="status" style="color:#06283c">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Botón de búsqueda -->
            <div class="col-12 col-md-auto">
                <button class="btn btn-sm" style="background-color: #f39c12; color: #06283c;"
                    :disabled="isSearchDisabled" @click="buscar">
                    Buscar
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    data() {
        return {
            isLoggedin: window.Laravel.isLoggedin,
            selectedYear: null,
            selectedMarca: 0,
            selectedModelo: 0,
            selectedMotor: 0,
            selectedLinea: 0,
            isLoading: false,
            isLoadingMarcas: false,
            isLoadingModelo: false,
            isLoadingMotor: false,
            isLoadingLineas: false,
            years: [],
            marcas: [],
            modelos: [],
            motores: [],
            lineas: [],
            busqueda: [],
        };
    },
    methods: {
        handleYearChange() {
            this.selectedMarca = 0;
            this.selectedModelo = 0;
            this.selectedMotor = 0;
            this.modelos = [];
            this.motores = [];
            this.loadMarcas();
        },
        handleMarcaChange() {
            this.selectedModelo = 0;
            this.selectedMotor = 0;
            this.modelos = [];
            this.motores = [];
            this.loadModelos();
        },
        handleModeloChange() {
            this.selectedMotor = 0;
            this.motores = [];
            this.loadMotores();
        },
        handleMotoresLineasChange() {
            //this.selectedMotor = 0;
            //this.motores = [];
            if (this.selectedMotor && !this.selectedLinea) {
                this.lineas = [];
                this.isLoadingLineas = true;
                this.loadMotoresLineas();
            }
            if (!this.selectedMotor && this.selectedLinea) {
                this.motores = [];
                this.isLoadingMotor = true;
                this.loadMotoresLineas();
            }

        },
        loadMarcas() {
            this.isLoadingMarcas = true;
            axios.post(`/catalogo/loadmarcasnuevo`, { year: this.selectedYear })
                .then((response) => {
                    this.marcas = response.data.marcas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingMarcas = false;
                });
        },
        loadModelos() {
            this.isLoadingModelo = true;
            axios.post(`/catalogo/loadmodelosnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca
            })
                .then((response) => {
                    this.modelos = response.data.modelos || [];
                    this.lineas = response.data.lineas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingModelo = false;
                });
        },
        loadMotores() {
            this.isLoadingMotor = true;
            axios.post(`/catalogo/loadmotoresnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo
            })
                .then((response) => {
                    this.motores = response.data.motores || [];
                    this.lineas = response.data.lineas || [];
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingMotor = false;
                });
        },
        loadMotoresLineas() {
            this.isLoadingMotor = true;
            axios.post(`/catalogo/loadmotoreslineasnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo,
                motor: this.selectedMotor,
                linea: this.selectedLinea
            })
                .then((response) => {
                    console.log(response)
                    if (!this.selectedMotor && this.selectedLinea)
                        this.motores = response.data.motores || [];
                    if (this.selectedMotor && !this.selectedLinea)
                        this.lineas = response.data.lineas || [];


                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingMotor = false;
                    this.isLoadingLineas = false;
                });
        },
        buscar() {
            this.$store.dispatch('resetBusquedaAvanzada');
            this.$emit('cerrar-offcanvas');
            this.$router.push({
                name: 'Resultados',
                query: {
                    year: this.selectedYear,
                    marca: this.selectedMarca,
                    modelo: this.selectedModelo,
                    motor: this.selectedMotor || 0,
                    linea: this.selectedLinea || 0,

                    idBusqueda: 0,
                    tipobusqueda: 0,
                    activoUsuario: 0,

                }
            });
        },
        buscar2(busqueda) {
            this.$store.dispatch('resetBusquedaAvanzada');
            this.$router.push({
                name: 'Resultados',
                query: {
                    year: busqueda.anio,
                    marca: busqueda.marca,
                    modelo: busqueda.modelo,
                    motor: busqueda.motor || 0,
                    linea: busqueda.idlinea || 0,
                    idBusqueda: busqueda.id,
                    tipobusqueda: 1,
                    activoUsuario: 1
                }
            });
        }
    },
    mounted() {
        this.isLoading = true;
        axios.get(`/catalogo/catalogocompletemountedNuevo`)
            .then((response) => {
                this.years = response.data.anios || [];
                this.marcas = response.data.marcas || [];
                this.busqueda = response.data.busqueda || [];
                if (this.years.length) {
                    this.selectedYear = this.years[0];
                }
            })
            .catch((error) => console.error(error))
            .finally(() => {
                this.isLoading = false;
            });
    },
    computed: {
        isSearchDisabled() {
            return !this.selectedYear || !this.selectedMarca || !this.selectedModelo;
        },
        isLineaDisabled() {
            return !this.selectedModelo;
        }
    },
};
</script>


<style scoped>
.booker-container {
    width: 100%;
    margin-top: 0;
    transition: all 0.2s ease-in-out;
}


/* Reset y Personalización del Select */
select {
    appearance: none;
    outline: none;
    border: 0;
    box-shadow: none;
    flex: 1;
    padding: 0.7em;
    color: #fff;
    background-color: #2c3e50;
    cursor: pointer;
    width: 100%;
    font-size: 12px;
    border-radius: 5px;
    scrollbar-width: thin;
    /* Puede ser auto, thin o none */
    scrollbar-color: #06283c #f1f1f1;
    /* Color del thumb y del track */
    height: 40px;
    /* Ajusta la altura */
    padding: 5px 10px;
    /* Espaciado interno */
    /* Tamaño de la letra */
    border-radius: 5px;
    /* Bordes redondeados */
    border: 1px solid #ccc;
    /* Borde sutil */
    appearance: none;
    /* Elimina los estilos por defecto del navegador */
}

/* Ocultar flecha en IE */
select::-ms-expand {
    display: none;
}

/* Contenedor del Select */
.select {
    position: relative;
    display: flex;
    width: 100%;
    height: 28px;
    font-size: 14px;
    border-radius: 5px;
    overflow: hidden;
    align-items: center;
}

/* Flecha de Select */
.select::after {
    content: '▼' !important;
    ;
    color: #fff;
    position: absolute;
    right: 10px;
    pointer-events: none;
    transition: 0.25s all ease;
    z-index: 2;
}

/* Hover en Select */
.select:hover::after {
    color: #f39c12;
}

select::-webkit-scrollbar {
    width: 8px;
    /* Ancho de la barra */
}

select::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* Color del fondo de la barra */
    border-radius: 10px;
}

select::-webkit-scrollbar-thumb {
    background: #06283c;
    /* Color del "botón" de desplazamiento */
    border-radius: 10px;
}

select::-webkit-scrollbar-thumb:hover {
    background: #041c2e;
    /* Color al pasar el mouse */
}

/* Estilo para la sección de búsqueda guardada */
.saved-search {
    top: 10px;
    right: 20px;
    background: #f8f9fa;
    padding: 10px 15px;
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #333;
}

.saved-search i {
    font-size: 18px;
    color: #007bff;
}

.saved-search-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

@media (max-width: 768px) {
    select {
        height: 45px;
    }
}
</style>